var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialmedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0346 0H10.9654C4.91906 0 0 4.91906 0 10.9655V29.0346C0 35.081 4.91906 40 10.9654 40H29.0346C35.081 40 40 35.081 40 29.0346V10.9655C40 4.91906 35.081 0 29.0346 0ZM37.6378 29.0346C37.6378 33.7784 33.7785 37.6378 29.0346 37.6378H10.9654C6.22156 37.6378 2.36219 33.7785 2.36219 29.0346V10.9655C2.36219 6.22156 6.22156 2.36219 10.9654 2.36219H29.0346C33.7785 2.36219 37.6378 6.22156 37.6378 10.9655V29.0346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0005 9.02867C13.9509 9.02867 9.0293 13.9503 9.0293 19.9998C9.0293 26.0494 13.9509 30.971 20.0005 30.971C26.05 30.971 30.9717 26.0493 30.9717 19.9998C30.9717 13.9502 26.05 9.02867 20.0005 9.02867ZM20.0005 28.6089C15.2534 28.6089 11.3914 24.7468 11.3914 19.9998C11.3914 15.2527 15.2534 11.3907 20.0005 11.3907C24.7476 11.3907 28.6096 15.2528 28.6096 19.9998C28.6096 24.7469 24.7476 28.6089 20.0005 28.6089ZM31.6279 5.03906C29.7899 5.03906 28.2946 6.53445 28.2946 8.37242C28.2946 10.2104 29.7899 11.7057 31.6279 11.7057C33.4659 11.7057 34.9612 10.2103 34.9612 8.37234C34.9612 6.53438 33.4659 5.03906 31.6279 5.03906ZM31.6279 9.34344C31.0925 9.34344 30.6568 8.90781 30.6568 8.37234C30.6568 7.83688 31.0925 7.40125 31.6279 7.40125C32.1634 7.40125 32.599 7.83695 32.599 8.37234C32.599 8.90773 32.1634 9.34344 31.6279 9.34344Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialmedia);
export default __webpack_public_path__ + "static/media/socialmedia.1137afdd5debb48f86a3d9a40465e7f8.svg";
export { ForwardRef as ReactComponent };